import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-placements-students-placed-create',
  templateUrl: './placements-students-placed-create.component.html',
  styleUrls: ['./placements-students-placed-create.component.scss']
})
export class PlacementsStudentsPlacedCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public departments = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/students-placedbyid/' + `${id}`).subscribe(
        data => {
          console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              name: data.data.name,
              image: data.data.image,
              imagealt: data.data.imagealt,
              placedin: data.data.placedin,
              desc: data.data.desc,
              department: data.data.department,
              year: data.data.year,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.Form = this.formBuilder.group({
      name: ['', Validators.required],
      imagealt: ['', Validators.required],
      image: ['', Validators.required],
      placedin: ['', Validators.required],
      desc: ['', Validators.required],
      department: ['', Validators.required],
      year: ['', Validators.required],
      _id: [''],
      seohidden: ['']
    })

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
      data => {
        // console.log(data.data);
        this.departments = data.data;
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "name" : this.Form.value.name,
      "image" : this.Form.value.image,
      "imagealt" : this.Form.value.imagealt,
      "desc" : this.Form.value.desc,
      "placedin" : this.Form.value.placedin,
      "department" : this.Form.value.department,
      "year" : this.Form.value.year,
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden": this.Form.value.seohidden
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/students-placed', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/students-placed/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "name" : this.Form.value.name,
      "image" : this.Form.value.image,
      "imagealt" : this.Form.value.imagealt,
      "desc" : this.Form.value.desc,
      "placedin" : this.Form.value.placedin,
      "department" : this.Form.value.department,
      "year" : this.Form.value.year,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
      "seohidden": this.Form.value.seohidden
    };
      console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/students-placed/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/students-placed/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
